import {
  Backdrop,
  alpha,
  CircularProgress,
  CircularProgressProps,
} from "@mui/material";
import theme from "../../../muiTheme";

interface LoadingComponentComponentProps {
  isLoading: boolean;
  backgroundColor?: string;
  position?: "absolute" | "relative" | "static" | "fixed";
  opacity?: number;
  width?: string | number;
  height?: string | number;
  size?: CircularProgressProps["size"];
}

const LoadingComponentComponent = ({
  isLoading,
  backgroundColor = theme.palette.background.default,
  position = "absolute",
  opacity = 0,
  width = "100%",
  height = "100%",
  size,
}: LoadingComponentComponentProps) => {
  const bgColor =
    backgroundColor === "transparent" ? "rgba(0, 0, 0, 0)" : backgroundColor;
  return (
    <Backdrop
      sx={{
        color: theme.palette.primary.main,
        backgroundColor: opacity ? alpha(bgColor, opacity) : bgColor,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: position,
        width,
        height,
      }}
      open={isLoading}
    >
      <CircularProgress size={size} color="inherit" />
    </Backdrop>
  );
};

export default LoadingComponentComponent;
